import { render, staticRenderFns } from "./SupportNewTicket.vue?vue&type=template&id=ef649844&"
import script from "./SupportNewTicket.vue?vue&type=script&lang=ts&"
export * from "./SupportNewTicket.vue?vue&type=script&lang=ts&"
import style0 from "./SupportNewTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports